export const gameHostConfig = {
    fantasyHost: `https://fantasysoccer.vodacomfantasy.com/`,
    predictorHost: `https://predictor.vodacomfantasy.com/`,
    portalHost: `https://www.vodacomfantasy.com/`,
}
